<app-admission-eight-class *ngIf="admissionClass == 8"></app-admission-eight-class>
<app-admission-eleven-class *ngIf="admissionClass == 11"></app-admission-eleven-class>
<app-sponsorship-program *ngIf="admissionClass == 100"></app-sponsorship-program>
<app-regular-classes *ngIf="admissionClass == 1"></app-regular-classes>
<app-day-scholars *ngIf="admissionClass == 365"></app-day-scholars>